import gql from 'graphql-tag';

export default gql`
  query getBrandItemsInSameProductGroups($brandId: Int!, $regionCode: String!, $pagination: Pagination!) {
    getBrandItemsInSameProductGroups(brandId: $brandId, regionCode: $regionCode, pagination: $pagination) {
      totalResults
      totalPage
      data {
        id
        supplier {
          id
          name
        }
        imageUrl
        note
        supplierInternalCode
        vat
        uom
        uomLocal
        price
        originalPrice
        savingAmount
        category {
          name
          parent {
            name
          }
        }
        inStock
        name
        isFavorite
        tags
        allowAddToCart
        private
        allowPurchase
        tagImageVn
        tagImageEn
        baseUnit
        baseUom
        netUom
        netUnit
        netUomPrice
        baseUomPrice
        priceV2 {
          price
          originalPrice
          vat
          vatIncluded
        }
      }
    }
  }
`;
